export const buildCogsHistoryRequestBody = (sku, marketplaceId) => ({
  sku,
  ...(marketplaceId != null && marketplaceId !== ""
    ? { marketplace_id: marketplaceId }
    : {}),
});

export const extractCogsHistoryRecords = (response) => {
  if (!response?.status) {
    return {
      records: [],
      errorMessage: response?.message || null,
    };
  }

  const data = response?.data;
  if (Array.isArray(data?.records)) {
    return { records: data.records, errorMessage: null };
  }
  if (Array.isArray(data)) {
    return { records: data, errorMessage: null };
  }
  if (Array.isArray(data?.summaryData)) {
    return { records: data.summaryData, errorMessage: null };
  }

  return { records: [], errorMessage: null };
};

export const normalizeCogsHistoryRecords = (records = []) =>
  [...records]
    .filter(
      (item) =>
        item &&
        item.item_cogs !== null &&
        item.item_cogs !== undefined &&
        item.item_cogs !== ""
    )
    .sort((a, b) => (a.created_at ?? 0) - (b.created_at ?? 0))
    .map((record) => ({
      id: record.id,
      cogs: parseFloat(record.item_cogs) || 0,
      batchStartDate: record.item_cogs_batch_start_date || "-",
    }));

export const buildFallbackCogsHistory = (currentCogs, batchStartDate) => {
  if (currentCogs === null || currentCogs === undefined || currentCogs === "") {
    return [];
  }

  const parsed = parseFloat(currentCogs);
  if (Number.isNaN(parsed)) return [];

  return [
    {
      id: "current-cogs",
      cogs: parsed,
      batchStartDate: batchStartDate || "Current",
    },
  ];
};

export const fetchCogsHistoryRecords = async ({
  sku,
  marketplaceId,
  token,
  currentCogs,
  currentBatchStartDate,
  makeApiCall,
}) => {
  if (!sku || !token) {
    return {
      records: buildFallbackCogsHistory(currentCogs, currentBatchStartDate),
      usedFallback: true,
      errorMessage: null,
    };
  }

  const response = await makeApiCall(
    "products/cogs-history?no_pagination=true",
    "post",
    buildCogsHistoryRequestBody(sku, marketplaceId),
    true,
    null,
    token
  );

  const { records: rawRecords, errorMessage } = extractCogsHistoryRecords(response);
  const records = normalizeCogsHistoryRecords(rawRecords);

  if (records.length > 0) {
    return { records, usedFallback: false, errorMessage: null };
  }

  const fallback = buildFallbackCogsHistory(currentCogs, currentBatchStartDate);
  return {
    records: fallback,
    usedFallback: fallback.length > 0,
    errorMessage,
  };
};
